import { render } from "./DescAiCrateView.vue?vue&type=template&id=27b6cfe8&scoped=true"
import script from "./DescAiCrateView.vue?vue&type=script&lang=js"
export * from "./DescAiCrateView.vue?vue&type=script&lang=js"

import "./DescAiCrateView.vue?vue&type=style&index=0&id=27b6cfe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b6cfe8"]])

export default __exports__